import React from 'react';

export default function PostFooter({author}) {
  return (
    <footer className="post-footer container">
      <figure className="post-author-avatar">
        <img src={author.avatar.childImageSharp.responsiveResolution.src} title={author.id} alt={author.id} />
      </figure>
      <div className="post-author-info">
        <h4>{author.id}</h4>
        {(author.bio !== '') &&
          <div>{author.bio}</div>
        }
        {(author.website !== '') &&
          <div><a href={`${author.website}`} title={`${author.id}'s website'`}>{author.website}</a></div>
        }
        {(author.twitter !== '') &&
          <div><a href={`https://twitter.com/${author.twitter}`} title={`${author.id} on Twitter`}>Twitter</a></div>
        }
        {(author.linkedin !== '') &&
          <div><a href={`https://linkedin.com/in/${author.linkedin}`} title={`${author.id} on Linkedin`}>Linkedin</a></div>
        }
      </div>
    </footer>
  )
}



// WEBPACK FOOTER //
// ./src/components/post-footer.jsx